import { useCallback, useState } from 'react';
import { Loader2, Receipt } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePaidOrders, useOrderWaybill } from './hooks/useWaybills';

interface Props {
  clientName: string;
}

export function WaybillsSection({ clientName }: Props) {
  const [pendingId, setPendingId] = useState<number | null>(null);

  const { data: orders, isLoading } = usePaidOrders([clientName], false);
  const orderWaybill = useOrderWaybill();

  const handleOrder = useCallback(
    (id: number) => {
      setPendingId(id);
      orderWaybill.mutate(id, {
        onSettled: () => setPendingId(null),
      });
    },
    [orderWaybill]
  );

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 p-3 text-muted-foreground">
        <Loader2 className="w-4 h-4 animate-spin" />
        <span className="text-sm">Загрузка накладных...</span>
      </div>
    );
  }

  if (!orders || orders.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2">
      <h4 className="text-sm font-medium flex items-center gap-2 text-emerald-700 dark:text-emerald-400">
        <Receipt className="h-4 w-4" />
        Заказ накладных ({orders.length})
      </h4>
      <div className="space-y-1">
        {orders.map((item) => (
          <div
            key={item.id}
            className="flex items-center justify-between p-2 rounded-lg border bg-emerald-50 dark:bg-emerald-950/30 border-emerald-200 dark:border-emerald-800"
          >
            <span className="text-sm flex-1 mr-2">{item.name}</span>
            <Button
              variant="outline"
              size="sm"
              className="bg-emerald-100 dark:bg-emerald-900/50 hover:bg-emerald-200 dark:hover:bg-emerald-800/50 border-emerald-300 dark:border-emerald-700 shrink-0"
              onClick={() => handleOrder(Number(item.id))}
              disabled={pendingId === Number(item.id)}
            >
              {pendingId === Number(item.id) ? (
                <Loader2 className="h-3 w-3 animate-spin" />
              ) : (
                'Заказать'
              )}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
